<template>
    <animation @visible="reInit">
    <div class="photo-card" ref="top">
        <v-card class="card">
            <div class="title-text text-center">
                {{title}}
            </div>
            <slick ref="slick" 
            :options="slickOptions"
            @afterChange="handleAfterChange">
                <div v-for="photo in photos" :key="photo">
                    <img class="img" :data-lazy="filename(photo)"/>
                </div>
            </slick>
            <div class="text-center" style="font-weight: bold;">
                {{photoNames[String(photos[currentSlide])].name}}
            </div>
            <div class="d-flex justify-center">
                <v-btn @click="prev" class="text-center" color="teal" outlined style="margin:5px">
                    <v-icon :size="resize ? '35px' : '25px'" left>mdi-menu-left</v-icon> PREV
                </v-btn>
                <v-btn @click="next" class="text-center" color="teal" outlined style="margin:5px">
                    NEXT <v-icon :size="resize ? '35px' : '25px'" right>mdi-menu-right</v-icon>
                </v-btn>
            </div>
            <div v-if="resize" v-html="text" style="padding: 10px 20px; font-size: 15px;"></div>
            <foldable-text v-if="!resize" :text="text" :top="top"></foldable-text>
        </v-card>
    </div>
    </animation>
</template>

<script>
    import Animation from './Animation.vue'
    import Slick from 'vue-slick'
    import FoldableText from './FoldableText.vue'
    import '../../node_modules/slick-carousel/slick/slick.css'
    import '../../node_modules/slick-carousel/slick/slick-theme.css'
    import '../../node_modules/slick-carousel/slick/slick.min.js'
    import photoNames from '../assets/photo.json'

    export default {
        name: 'PhotoCard',

        components: {
            Animation,
            Slick,
            FoldableText,
        },

        data: function() {
            return {
                slickOptions: {
                    centerMode: true,
                    variableWidth: true,
                    slidesToShow: 1,
                    centerPadding: '150px',
                    arrows: false,
                    dots: false,
                    lazyLoad: 'ondemand'
                },
                currentSlide: 0,
                photoNames: photoNames,
                width: window.innerWidth,
                top: 0,
                visible: false
            }
        },

        computed: {
            resize: function() {
                if(this.width < 600)
                    return false
                return true
            }
        },

        props: {
            title: {
                type: String
            },
            photos: {
                type: Array
            },
            text: {
                type: String
            }
        },

        mounted: function() {
            window.addEventListener('resize', this.handleResize)
            window.addEventListener('scroll', this.handleScroll)
        },

        beforeDestroy: function() {
            window.removeEventListener('resize', this.handleResize)
        },

        methods: {
            handleScroll: function() {
                this.top = this.$refs.top.getBoundingClientRect().top;
            },
            handleResize: function() {
                this.width = window.innerWidth;
            },
            handleAfterChange: function(event, slick, currentSlide) {
                this.currentSlide = currentSlide
            },
            next: function() {
                this.$refs.slick.next()
            },
            prev: function() {
                this.$refs.slick.prev()
            },
            filename: function(photo) {
                return require('../assets/pictures/' + photo + '.png')
            },
            reInit() {
                this.$nextTick(() => {
                    this.$refs.slick.reSlick();
                });
            },
        }
    }
</script>

<style scoped>
.card {
    border-radius: 20px;
}
.title-text {
    color: white;
    background-color: #98494C;
    font-size: 35px;
    font-weight: bold;
    padding: 5px 0;
}
.img {
    filter: drop-shadow(3px 3px 5px #666666);
    margin: 20px 10px;
    width: 70vw;
    max-width: 300px;
}
</style>